import { useQuery } from '@tanstack/react-query'
import { getCompany } from '@/lib/api/universe'

/** One company by slug, or null when it does not exist. */
export function useCompany(slug: string | undefined) {
  return useQuery({
    queryKey: ['universe', 'company', slug],
    queryFn: () => getCompany(slug!),
    enabled: !!slug,
    // Directory data changes rarely; 30s keeps back-navigation instant.
    staleTime: 30_000,
  })
}
